const $ = window.jQuery || {};

import Messages from "./utilities/messages";

class Product {
  constructor() {
    this.products = [];
    this.messages = new Messages();
    this.websiteUrl = siteUrl.url;
  }

  parseProductLink(data, callback) {
    $.ajax({
      url: ajax_object.ajax_url,
      method: "POST",
      data: {
        action: "parse_product_link",
        data: {
          link: data.link,
          quantity: data.quantity,
          comment: data.comment,
          order_note: data.order_note,
        },
      },
      success: (response) => {
        if (response.success) {
          this.addProductToList(response.data);
          this.messages.showSuccess(
            $("#success-message"),
            `Товар успешно добавлен <a href='${this.websiteUrl}/cart'>Перейти в корзину</a>`
          );
          if (callback) callback(null, response.data);
        } else {
          this.messages.showError($("#error-message"), response.data.message);
          if (callback) callback(new Error(response.data.message));
        }
      },
      error: (xhr, status, error) => {
        const errorMessage =
          "Произошла ошибка при обработке ссылки на товар. Проверьте правильность введенной ссылки, а так же принадлежность к магазину-партнеру и повторите попытку.";
        this.messages.showError($("#error-message"), errorMessage);
        if (callback) callback(new Error(errorMessage));
      },
    });
  }

  addProductToList(productData) {
    this.products.push(productData);
    this.renderProductList();
    $("#product-link-input").val("");
  }

  handleRemoveProduct(e) {
    const productId = $(e.target).data("product-id");
    this.products = this.products.filter((product) => product.id !== productId);
    this.renderProductList();
  }

  handleQuantityChange(e) {
    const productId = $(e.target).data("product-id");
    const newQuantity = parseInt($(e.target).val(), 10);

    if (newQuantity > 0) {
      const productIndex = this.products.findIndex(
        (product) => product.id === productId
      );
      if (productIndex !== -1) {
        this.products[productIndex].quantity = newQuantity;
        this.updateTotalPrice();
      }
    }
  }

  renderProductList() {
    const $productList = $("#product-list");
    $productList.empty();

    this.products.forEach((product) => {
      const productHtml = `
        <li class="product-item" data-product-id="${product.id}">
          <span class="product-name">${product.name}</span>
          <span class="product-price">${product.price}</span>
          <input type="number" class="product-quantity" value="${product.quantity}" min="1" data-product-id="${product.id}">
          <button class="remove-product-btn" data-product-id="${product.id}">Удалить</button>
        </li>
      `;
      $productList.append(productHtml);
    });

    this.updateTotalPrice();
  }

  updateTotalPrice() {
    const total = this.products.reduce((sum, product) => {
      return sum + product.price * product.quantity;
    }, 0);
    $("#total-price").text(`Итого: ${total.toFixed(2)} руб.`);
  }

  getProducts() {
    return this.products;
  }

  resetProducts() {
    this.products = [];
    this.renderProductList();
  }
}

export default new Product();
